/* eslint arrow-body-style: 0 */
import ContactsView from './components/ContactsView.vue';
import ContactManageView from './pages/ContactManageView.vue';
import { frontendURL } from '../../../helper/URLHelper';
import {
  dispatchAccountPreference,
  isExplicitAllViewQuery,
  resolveLastContactView,
} from '../../../helper/userPreferencesHelper';
import store from '../../../store';

const CONTACTS_SECTION_ROUTES = [
  'contacts_dashboard',
  'contacts_segments_dashboard',
  'contacts_labels_dashboard',
  'contacts_daily_tasks',
  'contact_profile_dashboard',
];

async function clearLastContactView(accountId) {
  await dispatchAccountPreference(store, accountId, 'last_contact_view', {
    type: 'all',
  });
}

async function resolveSavedContactView(accountId, lastContactView) {
  let segments = store.getters['customViews/getCustomViewsByFilterType'](
    'contact'
  );
  let labels = store.getters['labels/getLabels'];

  if (lastContactView.type === 'segment') {
    await store.dispatch('customViews/get', 'contact');
    segments = store.getters['customViews/getCustomViewsByFilterType'](
      'contact'
    );
  }

  if (lastContactView.type === 'label') {
    try {
      await store.dispatch('labels/getFresh');
      labels = store.getters['labels/getLabels'];
    } catch {
      return { valid: true, view: { type: 'all' } };
    }
  }

  return resolveLastContactView(lastContactView, { segments, labels });
}

function contactViewPath(accountId, view) {
  if (view.type === 'segment' && view.id) {
    return frontendURL(
      `accounts/${accountId}/contacts/custom_view/${view.id}`
    );
  }

  if (view.type === 'label' && view.id) {
    return frontendURL(`accounts/${accountId}/labels/${view.id}/contacts`);
  }

  return null;
}

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    name: 'contacts_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    beforeEnter: async (to, from, next) => {
      const { accountId } = to.params;

      if (isExplicitAllViewQuery(to)) {
        await dispatchAccountPreference(store, accountId, 'last_contact_view', {
          type: 'all',
        });
        next({ name: to.name, params: to.params, query: {}, replace: true });
        return;
      }

      const currentUser = store.getters.getCurrentUser;
      const userPrefs = currentUser?.ui_settings?.user_preferences_by_account;
      const lastContactView = userPrefs?.[accountId]?.last_contact_view;
      const isExplicitAllContactsNavigation =
        from?.name && CONTACTS_SECTION_ROUTES.includes(from.name);

      // Restore last view when entering Contacts from another section (e.g. Overview).
      // Skip restore when user clicks "All Contacts" while already in Contacts.
      if (
        !isExplicitAllContactsNavigation &&
        lastContactView &&
        lastContactView.type &&
        lastContactView.type !== 'all'
      ) {
        const { valid, view } = await resolveSavedContactView(
          accountId,
          lastContactView
        );

        if (!valid) {
          await clearLastContactView(accountId);
          next();
          return;
        }

        const targetPath = contactViewPath(accountId, view);
        if (targetPath && targetPath !== to.path) {
          next({ path: targetPath });
          return;
        }
      }

      next();
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/custom_view/:id'),
    name: 'contacts_segments_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    props: route => {
      return { segmentsId: route.params.id };
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/daily-tasks'),
    name: 'contacts_daily_tasks',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    props: () => ({ dailyTasksView: true }),
  },
  {
    path: frontendURL('accounts/:accountId/labels/:label/contacts'),
    name: 'contacts_labels_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    props: route => {
      return { label: route.params.label };
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    name: 'contact_profile_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactManageView,
    props: route => {
      return { contactId: route.params.contactId };
    },
  },
];
